export const genders = {
    MALE:"آقایان",
    FEMALE:"خانم ها",
    BOYS:"کودکان (پسر)",
    GIRLS:"کودکان (دختر)",
    NONE:"همه",
    KIDS:"کودکان",
}
export const userGenders = {
    MALE:"آقا",
    FEMALE:"خانم"
}
